import React, { useState, useEffect } from 'react';
import { Box, Modal, Typography, IconButton, Button, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 500,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const WebsiteRedirectModal = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem('hasSeenRedirectModal');
    if (!hasSeenModal) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    sessionStorage.setItem('hasSeenRedirectModal', 'true');
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', top: 8, right: 8, color: theme.palette.grey[500] }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          We've launched a brand new website!
        </Typography>
        <Typography variant="body1" gutterBottom>
          For the latest information and services, check out our new experience. You're welcome to continue browsing this legacy site as well.
        </Typography>
        <Box mt={2}>
          <Button
            href="https://www.knollwoodupfitters.com"
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color="primary"
            fullWidth
          >
            Visit New Website
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default WebsiteRedirectModal;
